export default "__VITE_ASSET__CMXgLGur__"